import m from "mithril"

var Google = {
  response: undefined,
  isReady: function() {
    return gapi != undefined && gapi.auth2 != undefined;
  },
  isSignedIn: function() {
    if (!Google.isReady() || !gapi.auth2.getAuthInstance()) return undefined;
    return gapi.auth2.getAuthInstance().isSignedIn.get();
  },

  load: function(callback) {
    window.gapi.load('client:auth2', callback);
  },
  initialized: false,
  clientInit: function() {
    return gapi.client.init({
      apiKey: 'AIzaSyAa4TAtUO637IOw5lMwLSA9xtu1IzhGOP0',
      clientId: '487328203590-k5og7kp6151hbkedi62qr4btsue1cefc.apps.googleusercontent.com',
      discoveryDocs: ['https://www.googleapis.com/discovery/v1/apis/tasks/v1/rest'],
      scope: 'https://www.googleapis.com/auth/tasks https://www.googleapis.com/auth/calendar.readonly',
      ux_mode: 'redirect' //document.singleWindowMode ? 'redirect' : 'popup'
    }).then(function() {
      document.setStatus("Loaded Google")
      Google.listenForSignIn();
    }, function(err){
      console.error("Could not load Google API", err.details);
    })
  },
  listenForSignIn: function() {
    var status = gapi.auth2.getAuthInstance().isSignedIn.get();
    gapi.auth2.getAuthInstance().isSignedIn.listen(Google.signInChanged);
    Google.signInChanged(status);
    document.setStatus(status ? "Signed in to Google" : "Sign in required")
    
  },
  
  signIn: function() {
    gapi.auth2.getAuthInstance().signIn();
  },
  signOut: function() {
    gapi.auth2.getAuthInstance().signOut();
    console.debug("Signing out", gapi.auth2.getAuthInstance().isSignedIn.get())
  },
  signedOutEvent: "gapi.signedOut",
  signInChanged: function(isSignedIn) {
      document.redraw()
  },
  signInContent: function() {
    return m('div', {class:'sign-in'},
    m('div.h2',"Sign in"),
    m('p',"Sign in to connect your tasks and schedule"),
    m('button', {id:'sign_in_button', onclick:Google.signIn}, "Sign in with Google"))
  }
}

module.exports = Google